import { render, staticRenderFns } from "./ProcessCreate.vue?vue&type=template&id=dd0b9ce6&"
import script from "./ProcessCreate.vue?vue&type=script&lang=js&"
export * from "./ProcessCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports